import { useState, useEffect } from 'react';
import config from './config';
import slugify from 'react-slugify';

export const useEventIds = () => {
    const [eventIds, setEventIds] = useState({
        // Evento actual
        currentEventID: null,
        currentEventID_en: null,
        currentEventID_pt_br: null,
        // Evento pasado
        pastEventID: null,
        pastEventID_en: null,
        pastEventID_pt_br: null,
        isLoading: true,
        error: null
    });

    const pastEventSlug = slugify(config.REACT_APP_PAST_EVENT_SLUG)  
    useEffect(() => {
        const fetchEventIds = async () => {
            try {
                const languages = ['es', 'en', 'pt-br'];
                
                // Función helper para hacer fetch con manejo de errores
                const fetchEventId = async (slug, lang) => {
                    try {
                        const response = await fetch(`${config.REACT_APP_API_URL}/our_events?slug=${slug}&lang=${lang}`);
                        
                        // Verificar que la respuesta sea exitosa
                        if (!response.ok) {
                            console.warn(`Error fetching event ID for ${slug} (${lang}): ${response.status} ${response.statusText}`);
                            return null;
                        }
                        
                        // Verificar que el content-type sea JSON
                        const contentType = response.headers.get('content-type');
                        if (!contentType || !contentType.includes('application/json')) {
                            console.warn(`Response is not JSON for ${slug} (${lang})`);
                            return null;
                        }
                        
                        const data = await response.json();
                        return Array.isArray(data) && data.length > 0 ? data[0] : null;
                    } catch (err) {
                        console.warn(`Error fetching event ID for ${slug} (${lang}):`, err);
                        return null;
                    }
                };
                
                // Fetch para evento actual
                const currentPromises = languages.map(lang => 
                    fetchEventId(config.REACT_APP_EVENT_SLUG, lang)
                );

                // Fetch para evento pasado
                const pastPromises = languages.map(lang => 
                    fetchEventId(pastEventSlug, lang)
                );

                // Ejecutar todas las promesas
                const [currentResults, pastResults] = await Promise.all([
                    Promise.all(currentPromises),
                    Promise.all(pastPromises)
                ]);
                
                const ids = {
                    // IDs evento actual
                    currentEventID: currentResults[0]?.id || null,
                    currentEventID_en: currentResults[1]?.id || null,
                    currentEventID_pt_br: currentResults[2]?.id || null,
                    // IDs evento pasado
                    pastEventID: pastResults[0]?.id || null,
                    pastEventID_en: pastResults[1]?.id || null,
                    pastEventID_pt_br: pastResults[2]?.id || null,
                    isLoading: false,
                    error: null
                };

                setEventIds(ids);
            } catch (error) {
                setEventIds(prev => ({
                    ...prev,
                    isLoading: false,
                    error: 'Error fetching event IDs'
                }));
                console.error('Error fetching event IDs:', error);
            }
        };

        fetchEventIds();
    }, [pastEventSlug]);

    return eventIds;
};